interface ApplyMaskProps {
  mask: string;
  regex: RegExp;
  value: string;
}

export const applyMask = ({ mask, regex, value }: ApplyMaskProps) =>
  value.replace(regex, mask).trim();
